
import { apis } from "../../constants/apis";
import httpService from "../httpService";
import { getStaticConfigs } from "../../helpers/common";
import axios from '../../utils/axios'

class MetaKeyService
{
  GetDetailMetaKey(id: string)
  {
    return httpService.get(`${apis.metaKey.default}/${id}`);
  }
}

export default new MetaKeyService();

export async function getMetakey(payload: any)
{
  return httpService.get(`${apis.metaKey.default}`, {
    params: payload,
  });
}

export async function getInfor()
{
  //user+ admin
  const staticConfigs = await getStaticConfigs();
  const _url =
    (staticConfigs?.REACT_APP_API_BASE_URL ?? "") +
    `/gh/sessions/whoami`

  return axios.get(_url);
}

export async function getGlobalConfigs(name: string)
{
  return httpService.get(`/vmrs/api/v1/global-configs/by-name/${name}`);
}

export async function getGroup()
{
  return httpService.get(`/vmrs/api/v1/groups`);
}

export async function getApplicationConfigs()
{
  const staticConfigs = await getStaticConfigs();

  const _url =
    (staticConfigs?.REACT_APP_API_BASE_URL ?? "") +
    `/gh/configs/eom/ui-config`

  return axios.get(_url);
}


export async function getConfigsDetailPage(key?: string)
{
  const staticConfigs = await getStaticConfigs();

  const _url =
    (staticConfigs?.REACT_APP_API_BASE_URL ?? "") +
    `/gh/configs/eom/${key}`;

  return axios.get(_url);
}


export async function getCommonSystem()
{
  const staticConfigs = await getStaticConfigs();
  const _url =
    (staticConfigs?.REACT_APP_API_BASE_URL ?? "") +
    `/gh/web-vmrs-common`;

  return axios.get(_url);
}